"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTextInputStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var color_1 = require("../theme/color");
exports.useTextInputStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, theme = __rest(_a, ["palette"]);
    return ({
        formControl: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
            display: "inline-flex",
            flexDirection: "column",
        },
        formLabel: {
            color: palette.text.primary,
            fontSize: "1rem",
            marginBottom: "0.75em",
            fontWeight: "bold",
            lineHeight: 1.2,
            "&.Mui-focused, &.Mui-error": {
                color: palette.text.primary,
            },
        },
        highlight: {
            "& $notchedOutline": {
                borderWidth: 2,
                borderColor: color_1.red["500"],
            },
        },
        notchedOutline: {},
        outlinedRoot: {
            padding: 0,
            backgroundColor: palette.common.white,
            "&.Mui-disabled": {
                "& svg": {
                    color: palette.grey[500],
                },
            },
            "& > textarea": {
                lineHeight: 1.5,
            },
        },
        search: {
            backgroundColor: "#F7F8F9",
        },
        outlinedAdornEnd: {
            paddingRight: 12,
        },
        outlinedInput: {
            padding: 12,
            height: "auto",
            minHeight: "auto",
            lineHeight: 1.15,
        },
        outlinedInputLarge: {
            padding: 15 / 16 + "rem 1rem",
        },
        inputAdornedStart: {
            paddingLeft: "2.5rem",
        },
        adornmentStart: {
            position: "absolute",
            left: 8,
        },
        adornmentEnd: {},
        selectInput: {
            // workaround for select, cannot pass classes to OutlinedInput
            // https://github.com/mui-org/material-ui/blob/v4.11.2/packages/material-ui/src/Select/Select.js#L21
            // https://github.com/mui-org/material-ui/blob/v4.11.2/packages/material-ui/src/Select/Select.js#L85
            "& .MuiOutlinedInput-inputAdornedStart": {
                paddingLeft: "2.5rem",
            },
            "& $outlinedInput": {
                paddingRight: 36,
            },
            "& $outlinedInput:focus": {
                backgroundColor: "unset",
            },
            "& svg:not(.MuiSvgIcon-root)": {
                fontSize: "1rem",
                marginTop: -8,
                marginBottom: -8,
                verticalAlign: "middle",
            },
        },
        selectInputHighlight: {
            "& .MuiOutlinedInput-notchedOutline": {
                borderWidth: 2,
                borderColor: color_1.red["500"],
            },
        },
        selectIcon: {
            top: "calc(50% - 0.75rem)",
        },
        selectStartIcons: {
            "& .MuiOutlinedInput-inputAdornedStart": {
                paddingLeft: "4rem",
            },
        },
        placeholder: {
            color: palette.grey[500],
        },
    });
}, { name: "TextInput" });
//# sourceMappingURL=TextInput.styles.js.map